import { NofeshService } from './../nofesh.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';



@Component({
    moduleId: module.id,
    templateUrl:'./tashlumim.component.html',
    selector: 'tashlumim'
})

export class TashlumimComponent implements OnInit{
    constructor(private _http: NofeshService){}
   
     ms_zehut_meshalem_valid = true;
     disable_nikuy = false;
    
    rdioChange(){
        let radion = this.tashlumForm.controls["ofen_tashlum"];
        console.log('radio click');
    }

    @Input('group')
    public tashlumForm: FormGroup;

    @Input() index;
    @Input() amitim: any[];
    // @Output() customValidation: EventEmitter<boolean> = new EventEmitter<boolean>();
    
    ngOnInit(){
        console.log(this.amitim)
    }
    onMsZehutMeshalemChange(value)
    {
        this.validNikuy(value);
        let valid_zehut = this.validatemsZehut(value);
        if (valid_zehut){
            this.ms_zehut_meshalem_valid = true;
        }
        else{
            this.ms_zehut_meshalem_valid = false;
        }    
    }

    validNikuy(value){
        //debugger;
        let valid = false;
        for(let amit of this.amitim){
            if (value == amit.ms_zehut){
                valid = true;
            }
        }
       if (!valid){
           this.tashlumForm.controls['ofen_tashlum'].patchValue('2');
          // (<HTMLInputElement>(document.getElementById("rdo_nikuy"+ "_" + this.index))).disabled = true;
           
       }
       else{
        (<HTMLInputElement>(document.getElementById("rdo_nikuy" + "_" + this.index))).disabled = false;
       }
    }

    validatemsZehut(value) {
           
        if (value.length == 0)
            return false;
        console.log(value.length);
    
    
        var result = true;
        var first8 = null;
        var cifratBikoret = null;
        try {
            if (value.length == 10)
                first8 = value.substring(0, 9);
            else {
                if (value.length == 9)
                    first8 = "0" + value.substring(0, 8);
                else
                    first8 = "00" + value.substring(0, 8);
            }
            cifratBikoret = value.substring(value.length - 1);
            var checkDigits = 0 * 1;
            var temp = 0;
            var i = 0;
    
            for (i = 1; i <= 9; i++) {
                temp = first8.charAt(i - 1);
                checkDigits = temp * 1 + checkDigits * 1;
                if ((i % 2) == 1) {
                    checkDigits = temp * 1 + checkDigits * 1;
                    if (temp > 4)
                        checkDigits = checkDigits * 1 - 9;
                }
            }
            checkDigits = (10 - checkDigits % 10) % 10;
            result = (checkDigits * 1 == cifratBikoret * 1);
        }
        catch (e) { result = false; }
        if (value == "0")
            result = false;
        return result;
    }

    // onCreditCardChange(credit){
    //    this.valid_credit_number = this.luhnChk(credit.value);
    //    if (!this.valid_credit_number){
    //    this.tashlumForm.controls['credit_number'].setValue('');
    //    }
    // //    this.customValidation.emit(this.valid_credit_number);
    // }

    // onTokefhChange() {
    //     let month = new Date().getMonth() + 1;
    //     let monthSelected = this.tashlumForm.controls['tokef_month'].value;
    //     let year = new Date().getFullYear();
    //     let yearSelected = this.tashlumForm.controls['tokef_year'].value;
    //     if (yearSelected && monthSelected) {
    //         if (+monthSelected < +month) {
    //             this.tokef_valid = false;
    //             this.tashlumForm.controls['tokef_month'].patchValue('');
    //         }
    //         else {
    //             this.tokef_valid = true;
    //         }
    //     }
        
    // }
}

    



